import {ErrorModel} from '../Store'
import {Component, React, observer, resolveCss} from '$src/handy'
import * as css from './ErrorCandy.css'
import DismissIcon from 'react-icons/lib/fa/close'

interface Props {
  css?: any
  error: typeof ErrorModel.Type
}

interface State {}

@observer
export default class ErrorCandy extends Component<Props, State> {
  constructor(props: Props, context: any) {
    super(props, context)
    this.state = {}
  }

  render() {
    const {props} = this
    const classes = resolveCss(css, props.css)

    return (
      <div {...classes('container')}>
        <div {...classes('message')}>{props.error.message}</div>
        <div {...classes('dismiss')} onClick={this.dismiss}>
          <DismissIcon />
        </div>
      </div>
    )
  }

  dismiss = () => {
    this.store.errors.remove(this.props.error.id)
  }
}



// WEBPACK FOOTER //
// ./src/bootstrap/Errors/ErrorCandy.tsx